import { Platform } from 'utils/platform';

import { TvPinModal } from './TvPinModal';
import { WebPinModal } from './WebPinModal';

export type PinModalVariant = 'setup' | 'verify';

export type PinModalProps = {
  variant?: PinModalVariant;
  isOpen: boolean;
  error?: boolean;
  onConfirm: (pin: string) => void;
  onCancel?: () => void;
};

export const PinModal = (props: PinModalProps) => {
  if (Platform.isTV) {
    return <TvPinModal {...props} />;
  }

  return <WebPinModal {...props} />;
};
